import { SignedOutLayoutResponse } from "../models/signed-out-layout-response";
import { get } from "./utils";

export const getSignedOutLayout = async (url: string) => await get<SignedOutLayoutResponse>(url);
